import { render } from "./ProductList.vue?vue&type=template&id=1ed41f12&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=1ed41f12&lang=scss&scoped=true"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed41f12"]])

export default __exports__